export default __webpack_public_path__ + "static/media/_DSC0771.4a882a97.JPG";